module.exports = __webpack_public_path__ + "static/media/artunity-mockup-4.0d43417f.jpg";